"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHeartRateSamples = exports.isPublicWorkout = exports.isSetType = exports.isRPE = exports.validRpeValues = exports.isSetPersonalRecordType = exports.weeklyTrainingFrequencies = exports.isGranularEquipment = exports.granularEquipments = exports.hevyTrainerProgramEquipments = exports.restTimerLengths = exports.exerciseCategories = exports.trainingLevels = exports.trainingGoals = exports.isCustomExerciseType = exports.customExericseTypes = exports.isExerciseType = exports.exerciseTypes = exports.isExerciseRepType = exports.exerciseRepTypes = exports.isEquipmentFilter = exports.equipmentFilters = exports.isEquipment = exports.equipments = exports.simplifiedMuscleGroupToMuscleGroups = exports.isMuscleGroupFilter = exports.muscleGroupFilters = exports.isMuscleGroup = exports.muscleGroups = exports.isSimplifiedMuscleGroup = exports.simplifiedMuscleGroups = exports.miscellaneousMuscles = exports.chestMuscles = exports.backMuscles = exports.legMuscles = exports.armMuscles = exports.shoulderMuscles = exports.coreMuscles = exports.DefaultClientConfiguration = exports.parseClientAuthTokenResponse = exports.isCoachRole = exports.isErrorResponse = exports.isLivePRVolumeOption = exports.isTimerVolumeOption = exports.isWeekday = exports.orderedWeekdays = exports.isBodyMeasurementUnit = exports.isDistanceUnitShort = exports.isDistanceUnit = exports.isWeightUnit = void 0;
exports.isOAuthScope = exports.supportedScopes = exports.isSuggestedUserSource = exports.isValidUserWorkoutMetricsType = exports.isBodyMeasurementKey = exports.measurementsList = exports.isHevyTrainerRoutine = exports.isWorkoutBiometrics = void 0;
const typeUtils_1 = require("./typeUtils");
__exportStar(require("./constants"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./units"), exports);
__exportStar(require("./filterExercises"), exports);
__exportStar(require("./setIndicatorUtils"), exports);
__exportStar(require("./workoutVolume"), exports);
__exportStar(require("./coachPlans"), exports);
__exportStar(require("./chat"), exports);
__exportStar(require("./websocket"), exports);
__exportStar(require("./cue"), exports);
__exportStar(require("./muscleHeatmaps"), exports);
__exportStar(require("./muscleSplits"), exports);
__exportStar(require("./notifications"), exports);
__exportStar(require("./normalizedWorkoutUtils"), exports);
__exportStar(require("./routineUtils"), exports);
__exportStar(require("./typeUtils"), exports);
__exportStar(require("./async"), exports);
__exportStar(require("./adminPermissions"), exports);
__exportStar(require("./adjustEventTokens"), exports);
__exportStar(require("./hevyTrainer"), exports);
__exportStar(require("./translations"), exports);
__exportStar(require("./exerciseLocaleUtils"), exports);
const isWeightUnit = (x) => {
    return x === 'kg' || x === 'lbs';
};
exports.isWeightUnit = isWeightUnit;
const isDistanceUnit = (x) => {
    return x === 'kilometers' || x === 'miles';
};
exports.isDistanceUnit = isDistanceUnit;
const isDistanceUnitShort = (x) => {
    return x === 'km' || x === 'mi';
};
exports.isDistanceUnitShort = isDistanceUnitShort;
const isBodyMeasurementUnit = (x) => {
    return x === 'cm' || x === 'in';
};
exports.isBodyMeasurementUnit = isBodyMeasurementUnit;
/** Monday is first */
exports.orderedWeekdays = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];
const isWeekday = (x) => (0, typeUtils_1.isInArray)(x, exports.orderedWeekdays);
exports.isWeekday = isWeekday;
const _timerVolumeOptions = ['off', 'low', 'normal', 'high'];
const isTimerVolumeOption = (x) => (0, typeUtils_1.isInArray)(x, _timerVolumeOptions);
exports.isTimerVolumeOption = isTimerVolumeOption;
const _livePRVolumeOption = ['off', 'low', 'normal', 'high'];
const isLivePRVolumeOption = (x) => (0, typeUtils_1.isInArray)(x, _livePRVolumeOption);
exports.isLivePRVolumeOption = isLivePRVolumeOption;
const isErrorResponse = (x) => {
    return typeof (x === null || x === void 0 ? void 0 : x.error) === 'string';
};
exports.isErrorResponse = isErrorResponse;
const _coachRoles = ['member', 'admin', 'owner'];
const isCoachRole = (role) => (0, typeUtils_1.isInArray)(role, _coachRoles);
exports.isCoachRole = isCoachRole;
const parseClientAuthTokenResponse = (data) => typeof data === 'object' &&
    !!data &&
    typeof data.access_token === 'string' &&
    data.access_token.length > 0 &&
    typeof data.refresh_token === 'string' &&
    data.refresh_token.length > 0 &&
    typeof data.expires_at === 'string' &&
    data.expires_at.length > 0 &&
    !!new Date(data.expires_at).valueOf()
    ? {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        expires_at: new Date(data.expires_at),
    }
    : null;
exports.parseClientAuthTokenResponse = parseClientAuthTokenResponse;
exports.DefaultClientConfiguration = {
    is_chat_enabled: false,
    are_notifications_enabled: true,
};
const _supportedProStores = [
    'app_store',
    'play_store',
    'stripe',
    'hevy-gift',
    'gympass',
    'paddle',
    'hevy-coach',
];
exports.coreMuscles = ['abdominals'];
exports.shoulderMuscles = ['shoulders'];
exports.armMuscles = ['biceps', 'triceps', 'forearms'];
exports.legMuscles = [
    'quadriceps',
    'hamstrings',
    'calves',
    'glutes',
    'abductors',
    'adductors',
];
exports.backMuscles = [
    'lats',
    'upper_back',
    'traps',
    'lower_back',
];
exports.chestMuscles = ['chest'];
exports.miscellaneousMuscles = [
    'cardio',
    'neck',
    'full_body',
    'other',
];
exports.simplifiedMuscleGroups = [
    'core',
    'shoulders',
    'arms',
    'legs',
    'back',
    'chest',
];
const isSimplifiedMuscleGroup = (x) => (0, typeUtils_1.isInArray)(x, exports.simplifiedMuscleGroups);
exports.isSimplifiedMuscleGroup = isSimplifiedMuscleGroup;
exports.muscleGroups = [
    ...exports.coreMuscles,
    ...exports.shoulderMuscles,
    ...exports.armMuscles,
    ...exports.legMuscles,
    ...exports.backMuscles,
    ...exports.chestMuscles,
    ...exports.miscellaneousMuscles,
];
const isMuscleGroup = (x) => (0, typeUtils_1.isInArray)(x, exports.muscleGroups);
exports.isMuscleGroup = isMuscleGroup;
exports.muscleGroupFilters = ['all_muscles', ...exports.muscleGroups];
const isMuscleGroupFilter = (x) => (0, typeUtils_1.isInArray)(x, exports.muscleGroupFilters);
exports.isMuscleGroupFilter = isMuscleGroupFilter;
exports.simplifiedMuscleGroupToMuscleGroups = {
    chest: exports.chestMuscles,
    shoulders: exports.shoulderMuscles,
    back: exports.backMuscles,
    arms: exports.armMuscles,
    legs: exports.legMuscles,
    core: exports.coreMuscles,
};
/**
 * Equipment
 */
exports.equipments = [
    'none',
    'barbell',
    'dumbbell',
    'kettlebell',
    'machine',
    'plate',
    'resistance_band',
    'suspension',
    'other',
];
const isEquipment = (x) => (0, typeUtils_1.isInArray)(x, exports.equipments);
exports.isEquipment = isEquipment;
exports.equipmentFilters = ['all_equipment', ...exports.equipments];
const isEquipmentFilter = (x) => (0, typeUtils_1.isInArray)(x, exports.equipmentFilters);
exports.isEquipmentFilter = isEquipmentFilter;
exports.exerciseRepTypes = [
    'weight_reps',
    'reps_only',
    'bodyweight_reps', // This is actually used for weighted bodyweight exercises (eg weighted pull ups)
    'bodyweight_assisted_reps',
];
const isExerciseRepType = (x) => (0, typeUtils_1.isInArray)(x, exports.exerciseRepTypes);
exports.isExerciseRepType = isExerciseRepType;
exports.exerciseTypes = [
    ...exports.exerciseRepTypes,
    'duration',
    'weight_duration',
    'distance_duration',
    /**
     * Note on short_distance_weight exercises. The UI makes it look like we support yards and meters
     * inputs, but in reality all inputs are considered to be meters. For example, if an imperial user inputs
     * 10 yards it'll be stored as 10 meters. It's mostly to account for the weird volume calculations that
     * would happen if we stored exact values in yards. The volume of a weight_reps set is weight*reps,
     * the volume of a short_distance_weight is weight*distance_meters if we converted yards to meters
     * imperial users would get a different volume value than metric users. To keep it simple and since
     * a meter is basically the same as a yard, we're not storing the value in yards and we convert 1-1
     * from yards<->meters.
     */
    'short_distance_weight',
    /**
     * At the time of writing, the only exercise that uses these types are Stair Machine (Floors)
     * and Stair Machine (Steps) respectively.
     */
    'floors_duration',
    'steps_duration',
];
const isExerciseType = (x) => (0, typeUtils_1.isInArray)(x, exports.exerciseTypes);
exports.isExerciseType = isExerciseType;
exports.customExericseTypes = exports.exerciseTypes.filter((type) => type !== 'floors_duration' && type !== 'steps_duration');
const isCustomExerciseType = (x) => (0, typeUtils_1.isInArray)(x, exports.customExericseTypes);
exports.isCustomExerciseType = isCustomExerciseType;
// Hevy Trainer related types
exports.trainingGoals = ['strength', 'build_muscle', 'fat_loss'];
exports.trainingLevels = ['beginner', 'intermediate', 'advanced'];
exports.exerciseCategories = [
    'isolation',
    'compound',
    'assistance-compound',
];
exports.restTimerLengths = ['short', 'medium', 'long'];
exports.hevyTrainerProgramEquipments = [
    'barbell',
    'dumbbell',
    'machine',
];
exports.granularEquipments = [
    'barbell',
    'dumbbell',
    'kettlebell',
    'plate',
    'medicine_ball',
    'ez_bar',
    'landmine',
    'trap_bar',
    'pullup_bar',
    'dip_bar',
    'squat_rack',
    'flat_bench',
    'adjustable_bench',
    'dual_cable_machine',
    'single_cable_machine',
    'lat_pulldown_cable',
    'leg_press_machine',
    'smith_machine',
    't_bar',
    'plate_machines',
    'stack_machines',
    'treadmill',
    'elliptical_trainer',
    'rowing_machine',
    'spinning',
    'stair_machine',
    'air_bike',
    'suspension_band',
    'resistance_band',
    'battle_rope',
    'rings',
    'jump_rope',
];
const isGranularEquipment = (x) => (0, typeUtils_1.isInArray)(x, exports.granularEquipments);
exports.isGranularEquipment = isGranularEquipment;
exports.weeklyTrainingFrequencies = [1, 2, 3, 4, 5, 6];
// Workouts
const _setPersonalRecordTypes = [
    'best_weight',
    'best_reps',
    'best_volume',
    'best_1rm',
    'best_duration',
    'best_distance',
    'most_floors',
    'most_steps',
];
const isSetPersonalRecordType = (x) => (0, typeUtils_1.isInArray)(x, _setPersonalRecordTypes);
exports.isSetPersonalRecordType = isSetPersonalRecordType;
exports.validRpeValues = [6, 7, 7.5, 8, 8.5, 9, 9.5, 10];
const isRPE = (x) => (0, typeUtils_1.isInArray)(x, exports.validRpeValues);
exports.isRPE = isRPE;
const _setTypes = ['warmup', 'normal', 'failure', 'dropset'];
const isSetType = (x) => (0, typeUtils_1.isInArray)(x, _setTypes);
exports.isSetType = isSetType;
const isPublicWorkout = (x) => {
    return x.type === 'public';
};
exports.isPublicWorkout = isPublicWorkout;
const isHeartRateSamples = (x) => {
    if (!x || !Array.isArray(x))
        return false;
    for (const sample of x) {
        if (typeof sample.timestamp_ms !== 'number' ||
            typeof sample.bpm !== 'number') {
            return false;
        }
    }
    return true;
};
exports.isHeartRateSamples = isHeartRateSamples;
const isWorkoutBiometrics = (x) => {
    if (!x)
        return false;
    const maybeCalories = x.total_calories;
    const maybeHeartRateSamples = x.heart_rate_samples;
    const caloriesAreValid = maybeCalories === undefined ||
        (typeof maybeCalories === 'number' && maybeCalories >= 0);
    const heartSamplesAreValid = maybeHeartRateSamples === undefined ||
        (0, exports.isHeartRateSamples)(maybeHeartRateSamples);
    return caloriesAreValid && heartSamplesAreValid;
};
exports.isWorkoutBiometrics = isWorkoutBiometrics;
const isHevyTrainerRoutine = (routine) => routine.hevy_trainer_program_id !== null;
exports.isHevyTrainerRoutine = isHevyTrainerRoutine;
exports.measurementsList = [
    'weight_kg',
    'lean_mass_kg',
    'fat_percent',
    'neck_cm',
    'shoulder_cm',
    'chest_cm',
    'left_bicep_cm',
    'right_bicep_cm',
    'left_forearm_cm',
    'right_forearm_cm',
    'abdomen',
    'waist',
    'hips',
    'left_thigh',
    'right_thigh',
    'left_calf',
    'right_calf',
];
const isBodyMeasurementKey = (key) => (0, typeUtils_1.isInArray)(key, exports.measurementsList);
exports.isBodyMeasurementKey = isBodyMeasurementKey;
const _validUserWorkoutMetricsTypes = ['duration', 'reps'];
const isValidUserWorkoutMetricsType = (x) => (0, typeUtils_1.isInArray)(x, _validUserWorkoutMetricsTypes);
exports.isValidUserWorkoutMetricsType = isValidUserWorkoutMetricsType;
const _suggestedUserSources = [
    'popular',
    'local',
    'contact',
    'mutual_follows',
    'follows_you',
    'featured',
    'hyper_local',
];
const isSuggestedUserSource = (source) => (0, typeUtils_1.isInArray)(source, _suggestedUserSources);
exports.isSuggestedUserSource = isSuggestedUserSource;
exports.supportedScopes = [
    'read-workout',
    'modify-workout',
    'read-routine',
    'modify-routine',
    'unrestricted',
];
const isOAuthScope = (x) => (0, typeUtils_1.isInArray)(x, exports.supportedScopes);
exports.isOAuthScope = isOAuthScope;
